const getAddressInputBaseUrl = () => {
  const deployEnv = process.env.DEPLOY_ENV || 'development';

  if (deployEnv === 'production') {
    return 'https://www.opendoor.com/_address-input';
  }

  return 'https://demo.simplersell.com/_address-input';
};

export const ALLOWED_TYPES = ['street_address', 'premise', 'subpremise', 'route'];

export const generateGoogleMapsSessionToken = () => {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};

export const buildAutocompleteUrl = (query: string, sessionToken: string) => {
  const baseUrl = getAddressInputBaseUrl();
  return `${baseUrl}/autocomplete?sessionToken=${sessionToken}&query=${query}`;
};

export const buildPlacesUrl = ({
  source,
  placeId,
  addressToken,
  sessionToken,
}: {
  source: 'google' | 'casa';
  placeId?: string;
  addressToken?: string;
  sessionToken: string;
}) => {
  const baseUrl = getAddressInputBaseUrl();
  const placeUrl = `${baseUrl}/place`;
  if (source === 'casa') {
    return placeUrl + `?addressToken=${addressToken}`;
  }
  return placeUrl + `?sessionToken=${sessionToken}&placeId=${placeId}`;
};
